module.exports = __webpack_public_path__ + "img/miki.87d5fa10.png";